import { createFileRoute } from "@tanstack/react-router";
import { PolicyPage } from "@/components/PolicyPage";

export const Route = createFileRoute("/policies/shipping-policy")({
  head: () => ({
    meta: [
      { title: "Shipping & Handling — Coyote Creek Hat Co." },
      { name: "description", content: "Shipping and handling details for Coyote Creek Hat Co. orders, including processing times, delivery estimates, rates, and tracking information." },
      { property: "og:title", content: "Shipping & Handling — Coyote Creek Hat Co." },
      { property: "og:description", content: "Shipping and handling details for Coyote Creek Hat Co. orders, including processing times, delivery estimates, rates, and tracking information." },
      { property: "og:url", content: "https://coyotecreekhatco.com/policies/shipping-policy" },
    ],
    links: [{ rel: "canonical", href: "https://coyotecreekhatco.com/policies/shipping-policy" }],
  }),
  component: () => <PolicyPage policyKey="shippingPolicy" fallbackTitle="Shipping & Handling" />,
});
